import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { usePostHog } from '@posthog/react';
import { capture, POSTHOG_PAGEVIEW_EVENT } from './posthog';

/**
 * Captures pageviews on route change for React Router. Rely on path for dashboard/section (no separate section event).
 * Render once inside Router so useLocation() works.
 */
export function PostHogPageView() {
  const location = useLocation();
  const posthog = usePostHog();
  const prevPathRef = useRef('');

  useEffect(() => {
    const path = location.pathname + location.search;
    if (!posthog || prevPathRef.current === path) return;
    prevPathRef.current = path;
    capture(posthog, POSTHOG_PAGEVIEW_EVENT, {
      $current_url: window.location.origin + location.pathname + location.search,
      path: location.pathname,
      search: location.search,
    });
  }, [location.pathname, location.search, posthog]);

  return null;
}
